import StandaloneNumberPicker from 'app/inputs/StandaloneNumberPicker'

export default ({ value, ...props }) => {
  const hours = Math.floor(value / 3600)
  const minutes = Math.floor((value - hours * 3600) / 60)
  const seconds = Math.floor(value - hours * 3600 - minutes * 60)

  return (
    <div className="frow gap-2 items-center mb-d">
      <StandaloneNumberPicker
        label="Hours"
        step={3600}
        value={value}
        {...props}
      >
        <div className="text-3xl font-digital">{hours}</div>
      </StandaloneNumberPicker>
      <StandaloneNumberPicker
        label="Minutes"
        step={60}
        value={value}
        {...props}
      >
        <div className="text-3xl font-digital">{minutes}</div>
      </StandaloneNumberPicker>
      <StandaloneNumberPicker label="Seconds" value={value} {...props}>
        <div className="text-3xl font-digital">{seconds}</div>
      </StandaloneNumberPicker>
    </div>
  )
}
